import React from "react";

export default function ExpenseSummaryCard() {

  return (

    <div className="card mb-4">

      <div className="card-body">

        Expense Summary

      </div>

    </div>

  );

}